module.exports = __webpack_public_path__ + "img/endologo.f80e34f0.png";